export default {
  filters: {
    show_all: false
  },
  paginationOptions: {}
};
